import React from 'react'
import { FormStepContext } from '../../FormStepContext'
import { useVmAiSession } from '../../hooks/useVmAiSession'
import { AIGenerationProvider } from '../../../AITaskCreation/AIGenerationProvider'
import { PromptGeneratorProvider } from '../../../AITaskCreation/PromptGeneratorContext'
import { VmAiWorkflow, VmAiEditorProps } from '../VmAiWorkflow'

/** Keep each stable card mounted while only its active stage enters/leaves the right panel. */
export function VmAiEditor(props: VmAiEditorProps) {
  const { context, onGenerated, complete, syncDraft } = useVmAiSession(props.index, props.onDone)

  return (
    <FormStepContext.Provider value={context}>
      <AIGenerationProvider
        onGenerated={onGenerated}
        promptSubmittedEvent="vm_ai_subtask_prompt_submitted"
        generatedEvent="vm_ai_subtask_generated"
      >
        <PromptGeneratorProvider>
          <VmAiWorkflow {...props} complete={complete} onDraftChange={syncDraft} />
        </PromptGeneratorProvider>
      </AIGenerationProvider>
    </FormStepContext.Provider>
  )
}
